import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  ShowPageContainer,
  ShowPageSectionContainer,
} from 'src/components/PageLayout/ShowPage'
import palette from 'src/designSystem/variables/palette'
import { $truncate } from 'src/globalStyles'
import styled, { css } from 'styled-components/macro'
import { DropdownSVG, ErrorSVG } from 'src/components/Icons/Basic'
import { NoResultsContainer } from 'src/components/PageLayout/NoResults/NoResults.styles'
import { StandardButton } from 'src/components/Reusable/Buttons'
import { PopupButtonContainer } from 'src/components/Reusable/Buttons/PopupButton/PopupButton.styles'
import { Markup } from 'src/components/Reusable/Text/Markup'
import { StyledPreviewModal } from 'src/components/Reusable/Document/DocumentViewer.styles'
import { border, compose } from 'styled-system'
import { ReactComponent as Add2SVG } from 'src/components/Icons/Basic/icons_add_2.svg'
import { ReactComponent as FileUploadIcon } from '../../components/Icons/assets/file-upload-icon.svg'
import { ReactComponent as InfoSVG } from '../../components/Icons/Basic/icons_info.svg'
import { FileInfoContainer } from '../CompanyInfoPage/modals/CompanyInfoModals.styles'

export const EvidenceIcon = styled(FileUploadIcon)`
  path {
    fill: ${palette.green[200]};
  }
`

export const EvidenceShowPageContainer = styled(ShowPageContainer)`
  height: 100%;
  display: flex;
  flex-direction: column;
`
export const EvidenceDescriptionTitle = styled.div`
  margin-bottom: 8px;
  font-weight: bold;
`

export const TestTableResultContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 8px 0;
  align-items: baseline;
`

export const TestTableResultStatus = styled.span<{ $passed: boolean }>`
  font-weight: 500;
  color: ${({ $passed }) =>
    $passed ? palette.green[500] : palette.magenta[600]};
`

export const TestTableResultDetail = styled.span`
  color: ${palette.neutral[600]};
`

export const EvidenceDescription = styled.div<{ $truncated?: boolean }>`
  padding: 0;
  .markup-section {
    padding: 0;
    ${({ $truncated }) =>
      $truncated &&
      `p {
      ${$truncate}
    }`}
    margin: 0;
  }
  margin-bottom: 16px;
`

export const EvidenceTimestamp = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${palette.neutral[600]};
`

export const EvidenceShowTabBody = styled.div`
  ${compose(border)}
  flex: 1 1 auto;
  padding: 8px;
  overflow-y: auto;
  border: 1px solid ${palette.neutral['100']};
`

export const EvidenceShowPageIcon = styled(FontAwesomeIcon)`
  color: ${palette.neutral[300]};
  font-weight: 900;
  height: 16px;
  width: 16px;
`

export const EvidenceNoResultsContainer = styled(NoResultsContainer)`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  justify-content: center;
  padding: 24px;
`

export const EvidenceNoResultsTitle = styled.div<{
  $isWarning?: boolean
}>`
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  font-weight: 400;
  font-size: 28px;
  ${({ $isWarning }) => $isWarning && `color: ${palette.magenta[500]};`}
`

export const EvidenceNoResultsIcon = styled(ErrorSVG)`
  width: 28px;
  height: 28px;
  path {
    fill: ${palette.magenta[500]};
  }
  margin-bottom: 2px;
`

export const PropertiesContainer = styled.div`
  border: 1px solid ${palette.neutral[100]};
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
`

export const AutomaticEvidenceContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 min-content;
  min-height: 0;
`

export const EvidenceFileName = styled.p`
  font-size: 14px;
  line-height: 150%;
  font-weight: 500;
  color: ${palette.neutral[600]};
`

export const EvidenceFileInfoContainer = styled(FileInfoContainer)`
  width: max-content;
  border-radius: 8px;
  margin-top: 16px;
  height: auto;
  padding: 16px 32px;
  svg {
    width: 120px;
    height: 120px;
  }
  flex-grow: 1;
`

export const EvidenceDropdownContainer = styled.div`
  width: max-content;
  button {
    padding: 12px;
  }
  .dropdown-toggle {
    display: flex;
    div {
      padding: 0 8px;
    }
  }
  margin-top: 24px;
`

export const ManualEvidenceContainer = styled(ShowPageSectionContainer)`
  h6 {
    margin-bottom: 8px;
  }
  margin-bottom: 16px;
`

export const RelevantDateButton = styled(StandardButton)`
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  border-color: ${palette.neutral[100]};
  border-radius: 4px;
  padding: 8px 24px;
  width: 100%;
  max-width: 420px;
`

export const StyledCsvModal = styled(StyledPreviewModal)`
  height: 100%;
  width: 100%;
  padding: 50px;
`

export const StyledCsvBody = styled.div`
  background-color: white;
  height: 90%;
  width: 90%;
  display: flex;
  flex: 1 1 auto;
  border: 5px solid ${palette.neutral['100']};
  min-height: 0;
`
export const EvidenceMarkdownContainer = styled.div`
  border: 1px solid ${palette.neutral[100]};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  min-height: 0;
`
export const EvidenceMarkdown = styled(Markup)`
  .markup-section {
    width: 100%;
    overflow: auto;
    white-space: pre-wrap;
  }
`

export const EvidenceDataGridContainer = styled.div`
  flex: 1 1 min-content;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  min-height: 0;

  .MuiDataGrid-root {
    border: none;
    height: 100%;
  }

  .MuiDataGrid-main {
    border: 1px solid ${palette.neutral['100']};
  }

  .MuiDataGrid-row.even {
    background-color: ${palette.neutral['30']};

    &:hover {
      background-color: ${palette.neutral['50']};
    }
  }

  .MuiDataGrid-row.odd:hover {
    background-color: ${palette.neutral['50']};
  }

  .evidence-grid-cell.MuiDataGrid-cell,
  .csv-grid-cell.MuiDataGrid-cell {
    border-bottom: none;
  }

  .MuiDataGrid-columnHeaders {
    border-bottom: none;
  }

  .MuiDataGrid-iconButtonContainer {
    width: auto;
    visibility: visible;
  }

  .MuiDataGrid-columnHeader.evidence-grid-column,
  .MuiDataGrid-columnHeader.csv-grid-column {
    font-family: 'Poppins', sans-serif;
    border-bottom: none;
    font-weight: 900;

    &:not(.MuiDataGrid-columnHeader--sorted) {
      .MuiDataGrid-sortIcon {
        opacity: 1;
      }
    }

    .MuiDataGrid-menuIcon {
      width: auto;
      right: 0;
      align-self: center;
      position: relative;
    }
    .MuiDataGrid-columnHeaderTitle {
      font-weight: 900;
    }
    .MuiDataGrid-iconSeparator {
      display: none;
    }
  }

  .evidence-grid-row,
  .csv-grid-row {
    font-family: 'Poppins', sans-serif;
  }

  .MuiDataGrid-footerContainer {
    border: 1px solid ${palette.neutral['100']};
    overflow: hidden;
    border-top: none;
  }
`

export const ShowMoreButton = styled.button<{ $expanded?: boolean }>`
  text-decoration: none;
  color: ${palette.blue[500]};
  font-size: 14px;
  font-weight: 400;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;

  ${({ $expanded }) =>
    $expanded
      ? `
    .show-more-icon {
      transform: scaleY(-1);
      transition: transform 0.35s;
    }
  `
      : `
    .show-more-icon {
      transform: scaleY(1);
      transition: transform 0.35s;
    }
  `}
`

export const ShowMoreIcon = styled(DropdownSVG).attrs({
  className: 'show-more-icon',
})`
  width: 16px;
  height: 16px;
  fill: ${palette.blue[500]};
`

export const EvidenceModalLabel = styled.label`
  color: ${palette.neutral[900]};
  font-weight: 400;
  font-size: 14px;
`

export const ProviderButton = styled.button`
  background: #fff;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: ${palette.neutral[900]};
  min-height: 60px;
  transition: background 0.2s ease-in-out;
  &:hover {
    background: ${palette.neutral[50]};
  }
`

export const AddIcon = styled(Add2SVG)`
  width: 20px;
  height: 20px;
`

export const InfoIcon = styled(InfoSVG)`
  width: 20px;
  height: 20px;
`

// The Relevant Date badge when a control test would ignore this evidence. Amber rather
// than red: out-of-window evidence is not an error, it just does not count yet.
// The notice sits directly above a grid, a tab card or a section header depending on the
// surface, none of which bring their own top margin. Without this it butts up against
// whatever follows.
export const OutOfWindowNoticeContainer = styled.div<{ $inset?: boolean }>`
  margin-bottom: 16px;
  // $inset matches GridContainer's horizontal padding, for the surfaces that render the
  // notice outside one. The evidence index's grid renders it inside GridContainer and is
  // already aligned, so padding it there would push it in twice.
  ${({ $inset }) => $inset && `padding: 0 24px;`}
`

// A ref-able target for the out-of-window pill's tooltip. OverlayTrigger clones its child
// to attach hover handlers and a ref, and Pill is a plain function component that forwards
// neither — without a real element in between, the tooltip never fires.
export const PillTooltipTarget = styled.span`
  display: inline-flex;
`

export const OutOfWindowDateButton = styled(PopupButtonContainer)`
  border-color: ${palette.orange[700]};
  background: ${palette.orange[30]};
  // Read-only badges pass $isDisabled: no hover, so they do not invite a click that does
  // nothing. Automated evidence and the link picker both render this without an editor.
  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover {
        background: ${palette.orange[50]};
      }
    `}
`
